import React from "react";
import { Chip, useTheme } from "@mui/material";
import { CrmContactStatus } from "../../types/companyTypes";

type ContactPreferenceChipProps = {
  crmContactAllowed?: boolean;
  crmContactStatus?: CrmContactStatus | null;
  size?: "small" | "medium";
};

/**
 * Primary CRM contact-preference chip.
 * This chip communicates whether further CRM contact is generally allowed.
 * More specific acquisition hints such as "potential follow-up project" are
 * rendered via separate secondary chips next to this baseline status.
 */
const ContactPreferenceChip: React.FunctionComponent<ContactPreferenceChipProps> = ({
  crmContactAllowed = true,
  crmContactStatus = CrmContactStatus.ACTIVE,
  size = "small",
}) => {
  const theme = useTheme();
  const noFurtherContact = !crmContactAllowed || crmContactStatus === CrmContactStatus.NO_FURTHER_CONTACT_DESIRED;
  const label = noFurtherContact ? "Kein Kontakt erwünscht" : "Kontakt erwünscht";
  const textColor = noFurtherContact ? theme.palette.error.dark : theme.palette.success.dark;
  const borderColor = noFurtherContact ? theme.palette.error.main : theme.palette.success.main;

  return (
    <Chip
      size={size}
      label={label}
      data-testid="contact-preference-chip"
      aria-label={label}
      variant="outlined"
      sx={{
        fontWeight: 400,
        color: textColor,
        backgroundColor: theme.palette.common.white,
        borderColor,
      }}
    />
  );
};

export default ContactPreferenceChip;
